import './404.scss';
import './img/logitec_404_bg_left.png';
import './img/logitec_404_bg_right.png';
import './img/logitec_404_bg_left_768.png';
import './img/logitec_404_bg_right_768.png';
import './img/logitec_404_bg_left_320.png';
import './img/logitec_404_bg_right_320.png';



// WEBPACK FOOTER //
// ./resources/views/partials/index/404/404.js